<template>
    <span class="bg-[#EBECF6] p-2 uppercase rounded px-2 py-1 text-sm font-semibold">
        Beta
    </span>
</template>

<script>
export default {};
</script>
